export class ReportStatusItem {
    status_id: number
    status_name: string
    count: number
}

export class UserReportResponseModel {
    count: number
    next: string
    previous: string
    results: UserReportModel[] 
}

export class TaskReportResponseModel {
    count: number
    next: string
    previous: string
    results: TaskReportModel[] 
}

export class ProjectReportResponseModel {
    count: number
    next: string
    previous: string
    results: ProjectReportModel[]
}

export class ClientReportResponseModel {
    count: number
    next: string
    previous: string
    results: ClientReportModel[]
}

export class ClientReportModel {
    name: string
    id: number
    project_report: ReportStatusItem[]
    task_report : ReportStatusItem[]
}
export class ProjectReportModel {
    id: number
    date: Date
    stats: ReportStatusItem[]
}


export class TaskReportModel {
    id: number
    date: Date
    stats: ReportStatusItem[]
}

export class ReportUserDetail {
    name: string
    email: string
    id: number
    image: string
}


export class UserReportModel {
    task: ReportStatusItem[]
    project: ReportStatusItem[]
    user_detail: ReportUserDetail 
}

export interface InvoiceFile {
    invoice_files: any[];
    quotation_files: any[];
    contract_files: any[];
}

export interface PaymentFile {
    payment_date: any;
    files: any[];
}

export class MasterReportModel {
    region: string | null;
    billing_entity: string | null;
    sales_invoice_number: string;
    event_id: number;
    event_name: string | null;
    sales_invoice_value: number;
    location: string | null;
    payment_type: string | null;
    number_of_pax: number;
    item_details: string;
    vendor_name: string;
    vendor_contact_name_and_email: string;
    project_type: string | null;
    client_name: string | null;
    date: string;
    month: string;
    invoice: any[];
    invoice_quote_contract_uploaded: InvoiceFile;
    buyerforesight_event_planner: string;
    currency: string;
    total_amount_payable: number;
    conversion_rate: number;
    amount_in_usd: number;
    projected_cost: number | null;
    payment_terms: string | null;
    advance_needed: number;
    advance_made: number;
    advance_payment_date_to_be_done_by: string | null;
    advance_payment_status: string | null;
    payment_mode_for_advance: string | null;
    payment_links: any[];
    final_balance_due_amount: number;
    final_balance_due_amount_usd: number;
    due_payment_date: string;
    final_payment_status: string | null;
    final_payment_done_on_link: PaymentFile;
    payment_mode: string | null;
    payment_remarks: string | null;
    client_reimbursement_amount: number | null;
    client_reimbursement_status: string | null;
    _event_name?: string;
}
 